import axios from 'axios'
import Cookies from 'js-cookie';
import Cookie from "js-cookie";
import qs from 'qs'

export interface IResponse<T> {
  data: T
  status: 12000 | 13000 | 13001 | 200 | 15001
}
const api = "2.12.16"
axios.interceptors.request.use(config => {
  config.params = config.params || {}
  config.headers = config.headers || {}
  const headers = {
    ...config.headers ,
    api: api,
    "device-id": Cookie.get("device_id"),
  };
  config.headers = headers;

  
  if (window.appToken) {
    config.params['token'] = window.appToken
    config.params['sessionReset'] = '1'
  }
  if (config.url === '/user-getLoginedNav.html') {
    config.data = true
    config.headers['Content-Type'] = 'application/json'
  }
  config.params['api'] = api;
  return config
})

export async function get<T>(url: string, params?: { [key: string]: any }, takeControl?: boolean) {
  return axios.get<IResponse<T>>(url, {
    withCredentials: true,
    params,
    headers: {
      'content-type': 'application/json',
      'accept': 'application/json'
    }
  })
    .then((res) => {
      return res.data
    })
}

export async function getV5<T>(url: string, params?: { [key: string]: any }) {
  return axios.get<IResponse<T>>(url, {
    withCredentials: true,
    params,
    headers: {
      'content-type': 'application/json',
      'accept': 'application/json',
      'token': process.env.SERVER_ENV === "production" ? Cookies.get("PHPSESSID") : Cookies.get("PHPSESSID_TEST")
    }
  })
    .then((res) => {
      return res.data
    })
}

export async function post<T>(url: string, data?: { [key: string]: any } | FormData, takeControl?: boolean) {
  let preload: any = data
  if (typeof data !== 'undefined' && typeof data === 'object' && !(data instanceof FormData)) {
    preload = qs.stringify(data)
  }
  return axios.post<IResponse<T>>(url, preload, {
    withCredentials: true,
  })
    .then((res) => {
      if (takeControl) {
        if (res.data.status === 12000) {
        } else {
        }
      }
      return res.data
    })
}

export function postRaw<T>(url: string, params = {}) {
  const qs = require('qs');
  let data: string | { [key: string]: any }
  if (!!Object.values(params).find(item => item instanceof File)) {
    data = new FormData()
    for (let key in params) {
      data.append(key, params[key])
    }
  } else {
    data = qs.stringify(params)
  }
  return axios.post<IResponse<T>>(url, data, {
    withCredentials: true,
  })
    .then((res: any) => {
      return res.data
    })
}